export const TRANSFER_GROUPS_START = 'TRANSFER_GROUPS_START';
export const TRANSFER_GROUPS_SUCCESS = 'TRANSFER_GROUPS_SUCCESS';
export const TRANSFER_GROUPS_ERROR = 'TRANSFER_GROUPS_ERROR';
